import * as React from 'react';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import IconButton from '@mui/joy/IconButton';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import DeleteForeverTwoToneIcon from '@mui/icons-material/DeleteForeverTwoTone';
import DeleteForeverSharpIcon from '@mui/icons-material/DeleteForeverSharp';
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';
import FourKIcon from '@mui/icons-material/FourK';
import ThreeSixtyIcon from '@mui/icons-material/ThreeSixty';
import { ContextFromSelections } from './Context';
import { useState, useContext } from 'react';
import { SvgIcon } from '@mui/material';
import {FormControl} from '@mui/material';
import {Typography} from '@mui/material';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';






 // remember to fetch original icons from db


export default function SelectIcon() {
    
    const [selectedData, setSelectedData] = useContext(ContextFromSelections)
    const [value, setValue] = useState(selectedData.icon);
    const action = React.useRef(null);
    
    const icons = [
        ThreeSixtyIcon,
        FourKIcon, 
        ThreeDRotationIcon, 
        DeleteForeverSharpIcon, 
        DeleteForeverTwoToneIcon, 
        DeleteForeverRoundedIcon,
        DeleteForeverOutlinedIcon,
        DeleteForeverIcon,
        DeleteSharpIcon,
        DeleteTwoToneIcon,

     ]

    
    
    return (
        
        <FormControl>
        <Typography fontSize={12} >Icon (soon)</Typography>
        <Select
        disabled
        size='sm'
        action={action}
        value={value}
        placeholder="Add Icon"
        renderValue={()=> <SvgIcon component={value}></SvgIcon>}
        onChange={(event, newValue) => {
            setValue(newValue)
            setSelectedData((data) => ({...data, "icon": newValue}))
        }}
        {...(value && {
         
            endDecorator: (
            <IconButton
                variant="plain"
                color="neutral"
                onMouseDown={(event) => {
                event.stopPropagation();
                }}
                onClick={() => {
                    
                    setValue(null);
                    setSelectedData((data) => ({...data, icon: null}))
                    action.current?.focusVisible();
                }}
            >
                <CloseTwoToneIcon />
            </IconButton>
            ),
            indicator: null,
        })}
        sx={{ 
            width:{ xs: 160, sm: 170},
            height: 30,
            fontSize: 13,
            fontStyle: '500',
     }}
        >
            
            {icons.map((icon,index) => (
                
                <Option key={index} value={icon}>
                  <SvgIcon component={icon} >
                  </SvgIcon>
                
                    </Option>
                
               
            ))}
            
            
        </Select>
           
        </FormControl>
  );
}

